import shortid from 'shortid'
import * as api from '../../requests'
import {
  SET_MISC_PUBLIC_SEARCH_TEMPLATE,
  SET_MISC_PUBLIC_SEARCH_TEMPLATE_LOADING,
  SET_MISC_PUBLIC_SEARCH_ITEMS,
  SET_MISC_PUBLIC_SEARCH_LOADING,
  SET_MISC_PUBLIC_SEARCH_ERROR,
  SET_MISC_PUBLIC_SEARCH_LAST_REQUEST_ID,
  SET_MISC_PUBLIC_SEARCH_FILTER,
  SET_MISC_PUBLIC_SEARCH_ADVANCED_FILTER,
  RESET_MISC_PUBLIC_SEARCH_FILTERS,
  SET_MISC_PUBLIC_SEARCH_ADVANCED_OPEN,
  SET_MISC_PUBLIC_SEARCH_SELECTED_RECORD_ID,
  SET_MISC_PUBLIC_SEARCH_DRAWER,
  SET_MISC_PUBLIC_SEARCH_DRAWER_LOADING,
  SET_MISC_PUBLIC_SEARCH_DRAWER_ERROR,
} from './MiscellaneousPublicSearchReducer'

export const setMiscPublicSearchTemplate = (template) => ({
  type: SET_MISC_PUBLIC_SEARCH_TEMPLATE,
  template,
})

export const setMiscPublicSearchTemplateLoading = (loading) => ({
  type: SET_MISC_PUBLIC_SEARCH_TEMPLATE_LOADING,
  loading,
})

export const setMiscPublicSearchItems = (items, totalCount) => ({
  type: SET_MISC_PUBLIC_SEARCH_ITEMS,
  items,
  totalCount,
})

export const setMiscPublicSearchLoading = (loading) => ({
  type: SET_MISC_PUBLIC_SEARCH_LOADING,
  loading,
})

export const setMiscPublicSearchError = (error) => ({
  type: SET_MISC_PUBLIC_SEARCH_ERROR,
  error,
})

export const setMiscPublicSearchLastRequestId = (requestId) => ({
  type: SET_MISC_PUBLIC_SEARCH_LAST_REQUEST_ID,
  requestId,
})

export const setMiscPublicSearchFilter = (key, value) => ({
  type: SET_MISC_PUBLIC_SEARCH_FILTER,
  key,
  value,
})

export const setMiscPublicSearchAdvancedFilter = (fieldName, value) => ({
  type: SET_MISC_PUBLIC_SEARCH_ADVANCED_FILTER,
  fieldName,
  value,
})

export const resetMiscPublicSearchFilters = () => ({
  type: RESET_MISC_PUBLIC_SEARCH_FILTERS,
})

export const setMiscPublicSearchAdvancedOpen = (open) => ({
  type: SET_MISC_PUBLIC_SEARCH_ADVANCED_OPEN,
  open,
})

export const setMiscPublicSearchSelectedRecordId = (recordId) => ({
  type: SET_MISC_PUBLIC_SEARCH_SELECTED_RECORD_ID,
  recordId,
})

export const setMiscPublicSearchDrawer = (data) => ({
  type: SET_MISC_PUBLIC_SEARCH_DRAWER,
  data,
})

export const setMiscPublicSearchDrawerLoading = (loading) => ({
  type: SET_MISC_PUBLIC_SEARCH_DRAWER_LOADING,
  loading,
})

export const setMiscPublicSearchDrawerError = (error) => ({
  type: SET_MISC_PUBLIC_SEARCH_DRAWER_ERROR,
  error,
})

export const fetchMiscRecordDrawer = (recordId) => (dispatch) => {
  dispatch(setMiscPublicSearchDrawerLoading(true))
  api.GET_MISC_RECORD_DRAWER(
    recordId,
    (data) => {
      dispatch(setMiscPublicSearchDrawer(data))
    },
    () => {
      dispatch(setMiscPublicSearchDrawerError('Failed to load record details.'))
    }
  )
}

export const fetchMiscPublicSearchTemplate = (moduleId) => (dispatch) => {
  dispatch(setMiscPublicSearchTemplateLoading(true))
  api.GET_MISC_PUBLIC_SEARCH_TEMPLATE(
    moduleId,
    (data) => {
      dispatch(setMiscPublicSearchTemplate(data))
    },
    () => {
      dispatch(setMiscPublicSearchTemplateLoading(false))
    }
  )
}

export const fetchMiscPublicSearchResults = (moduleId) => (dispatch, getState) => {
  dispatch(setMiscPublicSearchLoading(true))

  const { filters } = getState().miscPublicSearch
  const requestId = shortid.generate()
  dispatch(setMiscPublicSearchLastRequestId(requestId))

  const parameters = {
    search: filters.search || null,
    comparator: filters.comparator || null,
    registrationDateStart: filters.registrationDateStart || null,
    registrationDateEnd: filters.registrationDateEnd || null,
    ...filters.advancedFilters,
  }

  api.GET_MISC_PUBLIC_SEARCH_RESULTS(
    moduleId,
    parameters,
    requestId,
    (data, props = {}) => {
      if (getState().miscPublicSearch.lastRequestId === props.requestId) {
        dispatch(setMiscPublicSearchItems(data.Results || [], data.TotalCount || 0))
        dispatch(setMiscPublicSearchLoading(false))
      }
    },
    () => {
      if (getState().miscPublicSearch.lastRequestId === requestId) {
        dispatch(setMiscPublicSearchError('Failed to load search results.'))
      }
    }
  )
}
